import type * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

export interface Config {
  /**
   * Used to determine when the {@link Config} has truly changed
   */
  readonly id: string
  readonly title: string
  readonly subtitle?: string
  readonly color: string
  readonly logo: Config.Logo
}
export namespace Config {
  export interface Logo {
    readonly expanded: ents.core.display.Image
    readonly collapsed: ents.core.display.Image
  }

  export const DEFAULT: Config = {
    color: ds.color.Scale.PRIMARY.main,
    id: 'default',
    logo: {
      collapsed: {
        alt: 'Attain Partners logo mark',
        src: 'assets/img/attain-mark.png',
      },
      expanded: {
        alt: 'Attain Partners logo',
        src: 'assets/img/attain-partners-logo.png',
      },
    },
    title: 'Attain Apps',
  }
  export const ADMIN: Config = {
    ...DEFAULT,
    color: ds.color.Scale.SHADOW.main,
    id: 'admin',
    title: 'Admin Center',
  }
  export const GRAPHQL: Config = {
    ...DEFAULT,
    color: ds.color.Scale.SHADOW.main,
    id: 'graphql',
    // Pulled from https://www.apollographql.com/
    logo: {
      collapsed: {
        alt: 'Apollo GraphQL logo mark',
        src: 'data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%2078%2078%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22animated-logo_logo__noJiC%20animated-logo_theme-regolith__IZQIQ%22%3E%3Cpath%20d%3D%22M39%2077.5C60.263%2077.5%2077.5%2060.263%2077.5%2039C77.5%2017.737%2060.263%200.5%2039%200.5C17.737%200.5%200.5%2017.737%200.5%2039C0.5%2060.263%2017.737%2077.5%2039%2077.5Z%22%20fill%3D%22%23ffeadb%22%20stroke%3D%22%2315252d%22%3E%3C%2Fpath%3E%3Cpath%20d%3D%22M50.6771%2046.4275L49.4452%2042.9266L47.8229%2038.3168L46.6494%2034.9807L45.113%2030.6146L43.3283%2025.5435H34.6718L33.2901%2029.4703L32.0582%2032.9712L25.9397%2050.3582H31.6489L33.4399%2045.2831H42.098L40.5616%2040.917H34.9699L36.1435%2037.5809L38.5949%2030.6146L39.0001%2029.4616L39.4053%2030.6146L46.3496%2050.3543L46.3512%2050.3582H52.0604L50.6771%2046.4275Z%22%20fill%3D%22%2315252d%22%3E%3C%2Fpath%3E%3Cpath%20d%3D%22M61.5744%2026.2968C63.7606%2030.1732%2064.906%2034.5496%2064.899%2039C64.899%2053.3034%2053.3036%2064.8989%2039.0002%2064.8989C24.6968%2064.8989%2013.1013%2053.3034%2013.1013%2039C13.1013%2024.6966%2024.6968%2013.1012%2039.0002%2013.1012C43.6465%2013.0938%2048.2085%2014.3425%2052.2034%2016.7151%22%20stroke%3D%22%2315252d%22%20stroke-width%3D%222.20228%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20style%3D%22stroke-dashoffset%3A%200%3B%20stroke-dasharray%3A%20none%3B%22%3E%3C%2Fpath%3E%3Cg%20transform%3D%22rotate(0%2039%2039)%22%3E%3Cpath%20d%3D%22M53.7499%2021.1C55.6001%2021.1%2057.0999%2019.6002%2057.0999%2017.75C57.0999%2015.8999%2055.6001%2014.4%2053.7499%2014.4C51.8997%2014.4%2050.3999%2015.8999%2050.3999%2017.75C50.3999%2019.6002%2051.8997%2021.1%2053.7499%2021.1Z%22%20fill%3D%22%2315252d%22%20style%3D%22opacity%3A%201%3B%20visibility%3A%20inherit%3B%22%3E%3C%2Fpath%3E%3C%2Fg%3E%3C%2Fsvg%3E',
      },
      expanded: {
        alt: 'Apollo GraphQL ',
        src: 'https://www.apollographql.com/assets/footer/apollo-word-mark.svg',
      },
    },
    title: 'GraphQL Sandbox',
  }
}
